import React, { useState } from "react";
import { Button } from "@material-ui/core";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";

interface Props {
  stylez?: any;
}

export function ScrollToTopButton(props: Props) {
  const { stylez } = props;
  const [scrollValue, setScrollValue] = useState(0);
  window.onscroll = function() {
    if (document.documentElement.scrollTop > 200) {
      setScrollValue(100);
    } else {
      setScrollValue(0);
    }
  };

  if (scrollValue > 0) {
    return (
      <Button
        onClick={() => {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }}
        style={{
          height: "64px",
          boxShadow:
            "0 6px 6px 0 rgba(71, 71, 142, 0.22), 0 0 6px 0 rgba(50, 50, 93, 0.11), 0 0 6px 0 rgba(50, 50, 93, 0.21)",
          borderImageSource:
            " linear - gradient(to bottom, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.06) 20 %, rgba(255, 255, 255, 0))",
          borderImageSlice: 1,
          borderStyle: "solid",
          backgroundColor: "#5e72e4",
          position: "fixed",
          marginLeft: 10,
          bottom: 60,
          borderRadius: "50%",
          ...stylez
        }}
      >
        <ArrowUpwardIcon
          htmlColor="#ffffff"
          style={{ fontSize: "30px", height: 30 }}
        />
      </Button>
    );
  }
  return null;
}
